import React from 'react';
import { API_BASE_URL } from '../config/api';

const BACKEND_URL = API_BASE_URL;

const BrandMarquee = ({ brands: propBrands }) => {
  const brands = propBrands || [];

  if (brands.length === 0) return null;

  // Duplicate brands enough times for seamless loop
  const repeatedBrands = [...brands, ...brands, ...brands, ...brands];

  return (
    <section className="brand-marquee-section" data-testid="brand-marquee">
      <div className="brand-marquee-header">
        <h3 className="brand-marquee-title">Markalarımız</h3>
      </div>
      <div className="brand-marquee-track">
        <div className="brand-marquee-inner">
          {repeatedBrands.map((brand, idx) => (
            <a
              key={`${brand.id || brand.name}-${idx}`}
              href={brand.name ? `/books?brand=${encodeURIComponent(brand.name)}` : '/books'}
              className="brand-marquee-item"
              data-testid={`brand-item-${idx}`}
            >
              {brand.logo_url ? (
                <img
                  src={brand.logo_url.startsWith('/') ? `${BACKEND_URL}${brand.logo_url}` : brand.logo_url}
                  alt={brand.name}
                  className="brand-marquee-logo"
                  loading="lazy"
                />
              ) : (
                <span className="brand-marquee-text">{brand.name}</span>
              )}
            </a>
          ))}
        </div>
      </div>

      <style>{`
        .brand-marquee-section {
          padding: 3rem 0;
          overflow: hidden;
          background: linear-gradient(180deg, #fafafa 0%, #fff 50%, #fafafa 100%);
          border-top: 1px solid #f0f0f0;
          border-bottom: 1px solid #f0f0f0;
        }
        .brand-marquee-header {
          text-align: center;
          margin-bottom: 2rem;
        }
        .brand-marquee-title {
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          color: #9ca3af;
        }
        .brand-marquee-track {
          position: relative;
          width: 100%;
          overflow: hidden;
          mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
          -webkit-mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
        }
        .brand-marquee-inner {
          display: flex;
          align-items: center;
          gap: 4rem;
          width: max-content;
          animation: marquee-scroll 30s linear infinite;
        }
        .brand-marquee-inner:hover {
          animation-play-state: paused;
        }
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-25%); }
        }
        .brand-marquee-item {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 60px;
          min-width: 160px;
          text-decoration: none;
          transition: opacity 0.3s ease, transform 0.3s ease;
          opacity: 0.5;
        }
        .brand-marquee-item:hover {
          opacity: 1;
          transform: scale(1.08);
        }
        .brand-marquee-logo {
          max-height: 50px;
          max-width: 160px;
          object-fit: contain;
          filter: grayscale(100%);
          transition: filter 0.3s ease;
        }
        .brand-marquee-item:hover .brand-marquee-logo {
          filter: grayscale(0%);
        }
        .brand-marquee-text {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1f2937;
          white-space: nowrap;
          font-family: 'Georgia', serif;
          letter-spacing: -0.02em;
        }
        @media (max-width: 768px) {
          .brand-marquee-section { padding: 2rem 0; }
          .brand-marquee-inner { gap: 2.5rem; }
          .brand-marquee-item { min-width: 120px; height: 45px; }
          .brand-marquee-text { font-size: 1rem; }
        }
      `}</style>
    </section>
  );
};

export default BrandMarquee;
